import PropTypes from "prop-types";
import React, { useState } from "react";
import { Row, Col, CardBody, Card, Container, Form, Input, FormFeedback, Spinner } from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// Helpers & API
import { formatDataBeforeSend } from "helpers/GeneralHelper";
import { resetPassword } from "model/LoginModel";
import { toast } from "react-toastify";
import loginLogo from "../../assets/images/login-logo.png";

const ResetPassword = () => {
  document.title = "Reset Password | Funnl";
  const formatOptions = [];
  const [fields, setFields] = useState();
  const currentDate = new Date();
  const navigate = useNavigate();
  const { Token } = useParams();
  const [showSpinner, setShowSpinner] = useState(false);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);



  // Formik setup with Yup validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      Password: "",
      RePassword: "",
    },
    validationSchema: Yup.object({
      Password: Yup.string().required("Please Enter Your Password"),
      RePassword: Yup.string()
        .required("Please Enter Your Re-Password")
        .oneOf([Yup.ref("Password")], "Passwords must match"),
    }),
    onSubmit: async (values) => {
     setShowSpinner(true)
      const inputFields = {};
      setFields(inputFields);

      const formData = formatDataBeforeSend(inputFields, formatOptions);
      formData.append("Password", values.Password);
      formData.append("RePassword", values.RePassword);
      formData.append("Token", Token);

      try {
        const response = await resetPassword(formData);
        if (response?.IsSuccess) {
        setShowSpinner(false)
          toast.success(response?.Message || "Password reset successful!");
          navigate(`/login`);
        } else {
            setShowSpinner(false)
          toast.error(response?.Message || "Failed to reset password. Try again.");
        }
      } catch (err) {
        setShowSpinner(false)
        toast.error(err?.message || "An error occurred. Please try again.");
      }
    },
  });

  return (
    <div className="login-wrapper">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={6} lg={5} xl={4}>
            <div className="text-center mb-4">
              <img src={loginLogo} alt="logo" className="login-img-pos" />
            </div>
            <Card className={`p-2 border-0 shadow-sm ${isMobile ? 'card-wdth-mobile' : 'card-wdth'}`}>
              <CardBody>
                <h4 className="text-center mb-4 fw-bold">Reset Password</h4>
                <Form onSubmit={validation.handleSubmit}>
                  <div className="mb-3">
                    <Input
                      name="Password"
                      placeholder="Password"
                      type="password"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.Password}
                      invalid={!!(validation.touched.Password && validation.errors.Password)}
                    />
                    {validation.touched.Password && validation.errors.Password && (
                      <FormFeedback>{validation.errors.Password}</FormFeedback>
                    )}
                  </div>

                  <div className="mb-3">
                    <Input
                      name="RePassword"
                      placeholder="Re-Password"
                      type="password"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.RePassword}
                      invalid={!!(validation.touched.RePassword && validation.errors.RePassword)}
                    />
                    {validation.touched.RePassword && validation.errors.RePassword && (
                      <FormFeedback>{validation.errors.RePassword}</FormFeedback>
                    )}
                  </div>

                  <div className="d-grid">
                    <button type="submit" className="btn btn-gradient" disabled={showSpinner}>
                    {showSpinner && <Spinner size="sm" />} Continue <span className="ms-1">→</span>
                    </button>
                  </div>

                  <div className="text-center mt-3">
                    Wait, I remember my password...{" "}
                    <Link to="/login" className="text-orange fw-medium">
                      Click Here
                    </Link>
                  </div>
                </Form>
              </CardBody>
            </Card>
            <div className="text-center mt-4 text-muted small">
              ©{currentDate?.getFullYear()} Powered by Funnl
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default withRouter(ResetPassword);

ResetPassword.propTypes = {
  history: PropTypes.object,
};
